module.exports = __webpack_public_path__ + "static/media/share.5aebfa97.png";